module.exports = __webpack_public_path__ + "img/icon_card_play.f9c1e4a0.png";